import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router"
import { Banner } from "@/components/ui/banner.tsx"
import { Button } from "@/components/ui/button"
import { getInsensitiveSearchParams } from "@/lib/get-insensitive-search-params"
import { TelephonySearchParams } from "@/modules/patients/constants/Patient"
import { useSharedMedicalRecordNoteStore } from "@/modules/patients/stores/useSharedMedicalRecordNoteStore"
import useCallContextStore from "@/stores/useCallContextStore"

export const InboundCallBanner = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const callId = useCallContextStore((state) => state.callID)
  const clearCallStore = useCallContextStore((state) => state.clearStore)
  const clearSharedMedicalRecordNotes = useSharedMedicalRecordNoteStore((state) => state.clearStore)

  const removeSpecificSearchParams = (locationSearch: string): string => {
    const paramsToRemove = Object.values(TelephonySearchParams)
    const searchParams = new URLSearchParams(locationSearch)

    for (const param of paramsToRemove) {
      const insensitiveParam = getInsensitiveSearchParams(searchParams, param)
      if (insensitiveParam.exists) {
        searchParams.delete(insensitiveParam.key)
      }
    }

    return searchParams.toString() ? `?${searchParams.toString()}` : ""
  }

  const searchParams = removeSpecificSearchParams(location.search)

  const onHandleRemoveIbcContext = () => {
    clearCallStore()
    clearSharedMedicalRecordNotes()
    if (location.pathname === "/patients") {
      navigate(location.pathname + searchParams)
    }
  }

  return (
    <div className="flex items-center justify-between">
      {callId && (
        <Banner
          type="full-width"
          variant="info"
          className="pt-1 pb-1"
          iconClassName="pt-2"
          data-testid="in-ibc-context-banner">
          {t("patient.ibc.banner.information")}
          <Button
            variant={"tertiary"}
            onClick={onHandleRemoveIbcContext}
            className="ml-auto pl-4"
            data-testid="remove-ibc-context-button">
            {t("patient.ibc.banner.buttonRemove")}
          </Button>
        </Banner>
      )}
    </div>
  )
}
